const INFO = {
	main: {
		title: "Portfolio",
		name: "Prajwal Shrestha",
		email: "pjkoju@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		twitter: "https://twitter.com/",
		github: "https://github.com/ShresthaPrajwal",
		linkedin: "https://www.linkedin.com/in/prajwal-shrestha-440b98215/",
		instagram: "https://www.instagram.com/_prajwalshrestha/",
	},

	homepage: {
		title: "Full-stack Engineer.",
		description: "I am fullstack developer having skill on MERN stack.",
	},

	about: {
		title: "I am Prajwal Shrestha.",
		description:
			"I have completed my Bachelors in Computer Engineering and have been working personally on MERN projects with no professional experience till now but I'm  filled with enthusiasm and motivation to embark journey as fullstack developer.",
	},

	projects: [
		{
			title: "Blog Backend",
			description:
				"Backend for blog sites implemented with express.js/node.js with mongo DB as database.",
			logo: "https://www.cdnlogo.com/logos/n/49/node-js.svg",
			linkText: "View Project",
			link: "https://github.com/ShresthaPrajwal/Blog_backend.git",
		},

		{
			title: "E-commerce Website",
			description:
				"Fully functional E-commerce site made with React.js on frontend and firebase as backend computing service.",
			logo: "https://www.cdnlogo.com/logos/r/29/react-native-firebase.svg",
			linkText: "View Project",
			link: "https://github.com/ShresthaPrajwal/E-commerce-Site.git",
		},

		{
			title: "E-commerce Android Application",
			description:
				"Fully functional E-commerce site made with Flutter on frontend and firebase as backend computing service.",
			logo: "https://www.cdnlogo.com/logos/f/30/flutter.svg",
			linkText: "View Project",
			link: "https://github.com/ShresthaPrajwal/E-Commerce-App-PASALE-.git",
		},
	],
};

export default INFO;
